module.exports = __webpack_public_path__ + "static/media/payoneer.4af74d7f.svg";